import { useMemo } from 'react';

import type { IRate } from 'modules/api-requests/rates/types';
import { ITableTeeTime } from '../../../modules/api-requests/tee-time/types';
import { flatMap, isNil } from 'lodash';

export const useRatesWithPrices = (
  teeTimeRates: Array<{ id: string; price: number | null }>,
  ratesList: IRate[] = []
): Array<IRate & { price: number | null }> => {
  return useMemo(() => {
    return ratesList
      .filter((rate) =>
        teeTimeRates
          .filter((x) => typeof x.price === 'number')
          .map((item) => item.id)
          .includes(rate.id)
      )
      .map((rate) => ({ ...rate, price: teeTimeRates.find((item) => item.id === rate.id)?.price ?? null }));
  }, [teeTimeRates, ratesList]);
};

export const useAvailableRates = (teeTimes: ITableTeeTime[] = [], ratesList: IRate[] = []): IRate[] => {
  return useMemo(() => {
    const teeTimeRateIds = flatMap(teeTimes, function (teeTime) {
      return Object.values(teeTime.rates).filter((rate) => !isNil(rate.price));
    }).map((x) => x.id);
    return ratesList.filter((rate) => teeTimeRateIds.includes(rate.id));
  }, [teeTimes, ratesList]);
};

